<div class="notification-inbox">
  <!-- Bell Icon Button -->
  <button
    mat-icon-button
    class="bell-button"
    (click)="toggleDropdown()"
    [attr.aria-expanded]="isOpen()"
    aria-label="Notifications"
  >
    <mat-icon
      [matBadge]="
        notificationService.unseenCount() > 0
          ? notificationService.unseenCount()
          : null
      "
      matBadgeColor="warn"
      matBadgeSize="small"
      [matBadgeHidden]="notificationService.unseenCount() === 0"
      aria-hidden="false"
    >
      notifications
    </mat-icon>
  </button>

  <!-- Dropdown Panel -->
  @if (isOpen()) {
    <div class="dropdown-panel" role="menu">
      <!-- Header -->
      <div class="dropdown-header">
        <h3>Notifications</h3>
        <button
          mat-button
          class="mark-all-btn"
          (click)="markAllRead()"
          [disabled]="notificationService.unseenCount() === 0"
        >
          Mark all read
        </button>
      </div>
      <!-- Filter Tabs -->
      <div class="filter-tabs">
        <button
          class="tab-btn"
          [class.active]="activeTab() === 'all'"
          (click)="setTab('all')"
        >
          All
          @if (notificationService.unseenCount() > 0) {
            <span class="tab-badge">
              {{ notificationService.unseenCount() }}
            </span>
          }
        </button>
        <button
          class="tab-btn"
          [class.active]="activeTab() === 'jobs'"
          (click)="setTab('jobs')"
        >
          Jobs
        </button>
        <button
          class="tab-btn"
          [class.active]="activeTab() === 'invites'"
          (click)="setTab('invites')"
        >
          Invites
        </button>
      </div>
      <!-- Notification List -->
      <div class="notification-list">
        <!-- Loading -->
        @if (notificationService.loading()) {
          <div class="empty-state">
            <mat-icon>hourglass_empty</mat-icon>
            <p>Loading notifications...</p>
          </div>
        }
        <!-- Empty State -->
        @if (!notificationService.loading() && filteredEntries().length === 0) {
          <div class="empty-state">
            <mat-icon>notifications_none</mat-icon>
            <p>No notifications yet</p>
          </div>
        }
        <!-- Entries -->
        @for (entry of filteredEntries(); track entry.entryId) {
          <div class="notification-item" [class.unseen]="!entry.entrySeen">
            <div class="item-icon">
              <mat-icon>{{ getEntryIcon(entry) }}</mat-icon>
            </div>
            <div class="item-content">
              <p class="item-message">{{ entry.message }}</p>
              <div class="item-meta">
                @if (getProjectName(entry)) {
                  <span class="item-project">{{ getProjectName(entry) }}</span>
                }
                <span class="item-time">{{ getTimeAgo(entry.entryDate) }}</span>
              </div>
            </div>
            @if (!entry.entrySeen) {
              <div class="unseen-dot"></div>
            }
          </div>
        }
      </div>
      <!-- Footer -->
      <div class="dropdown-footer">
        <a routerLink="/notifications" (click)="closeDropdown()"
          >View all notifications</a
        >
      </div>
    </div>
  }
</div>
